import { useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import { CERTIFICATE_QUERY } from '../../queries';

export function useCertificateQuery( certificateTemplateId, options ) {
    const [ fetchCertificate, { data: rawData, loading, error, refetch, called } ] = 
        useLazyQuery( CERTIFICATE_QUERY, {
            ...options,
            variables: { 
                ...options?.variables, 
                certificateTemplateId: certificateTemplateId 
            },
        } );

    return useMemo ( () => {
        return {
            fetch: fetchCertificate,
            error,
            loading,
            data: rawData,
            refetch,
            called
        };
    }, [ error, loading, rawData, refetch ] );
}
